import React, { useState, useEffect } from 'react';
import { hotelParceiroService } from '../services/api';
import { toast } from 'react-toastify';

function HoteisParceiros() {
    const [hoteis, setHoteis] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mostrarForm, setMostrarForm] = useState(false);
    const [hotelEdicao, setHotelEdicao] = useState(null);

    const formVazio = { nome: '', cnpj: '', local: '', telefone: '' };
    const [formData, setFormData] = useState(formVazio);

    useEffect(() => {
        carregarHoteis();
    }, []);

    const carregarHoteis = async () => {
        try {
            setLoading(true);
            const res = await hotelParceiroService.listarTodos();
            setHoteis(res.data);
        } catch (error) {
            toast.error('Erro ao carregar hotéis parceiros');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNovo = () => {
        setHotelEdicao(null);
        setFormData(formVazio);
        setMostrarForm(true);
    };

    const handleEditar = (hotel) => {
        setHotelEdicao(hotel);
        setFormData({
            nome: hotel.nome || '',
            cnpj: hotel.cnpj || '',
            local: hotel.local || '',
            telefone: hotel.telefone || ''
        });
        setMostrarForm(true);
    };

    const handleCancelar = () => {
        setHotelEdicao(null);
        setFormData(formVazio);
        setMostrarForm(false);
    };

    const formatarCnpj = (cnpj) => {
        if (!cnpj) return '-';
        const c = cnpj.replace(/\D/g, '');
        return c.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // remove máscara do CNPJ antes de enviar
        const dadosParaEnviar = {
            ...formData,
            cnpj: formData.cnpj.replace(/\D/g, '')
        };

        try {
            if (hotelEdicao) {
                await hotelParceiroService.atualizar(hotelEdicao.id, dadosParaEnviar);
                toast.success('✅ Hotel parceiro atualizado!');
            } else {
                await hotelParceiroService.cadastrar(dadosParaEnviar);
                toast.success('✅ Hotel parceiro cadastrado!');
            }
            setMostrarForm(false);
            setHotelEdicao(null);
            setFormData(formVazio);
            carregarHoteis();
        } catch (error) {
            toast.error(error.response?.data?.mensagem || error.response?.data || '❌ Erro ao salvar');
        }
    };

    const handleDeletar = async (hotel) => {
        if (!window.confirm(`Excluir o hotel "${hotel.nome}"?`)) return;
        try {
            await hotelParceiroService.deletar(hotel.id);
            toast.success('✅ Hotel parceiro excluído!');
            carregarHoteis();
        } catch (error) {
            toast.error(error.response?.data || '❌ Erro ao excluir');
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>🏨 Hotéis Parceiros</h2>
                {!mostrarForm && (
                    <button className="btn btn-primary" onClick={handleNovo}>
                        ➕ Novo Hotel Parceiro
                    </button>
                )}
            </div>

            {/* FORMULÁRIO */}
            {mostrarForm && (
                <div className="card mb-4">
                    <div className="card-header">
                        <h5 className="mb-0">
                            {hotelEdicao ? '✏️ Editar Hotel Parceiro' : '➕ Cadastrar Hotel Parceiro'}
                        </h5>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Nome *</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        placeholder="Ex: Hotel Ibis Centro"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">CNPJ *</label>
                                    <input
                                        type="text"
                                        name="cnpj"
                                        className="form-control"
                                        value={formData.cnpj}
                                        onChange={handleChange}
                                        placeholder="Ex: 00.000.000/0000-00"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Local (Endereço e Cidade) *</label>
                                    <input
                                        type="text"
                                        name="local"
                                        className="form-control"
                                        value={formData.local}
                                        onChange={handleChange}
                                        placeholder="Ex: Rua das Flores, 123 - São Paulo/SP"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">Telefone</label>
                                    <input
                                        type="text"
                                        name="telefone"
                                        className="form-control"
                                        value={formData.telefone}
                                        onChange={handleChange}
                                        placeholder="Ex: (11) 99999-9999"
                                    />
                                </div>
                            </div>
                            <div className="d-flex gap-2">
                                <button type="submit" className="btn btn-primary">
                                    {hotelEdicao ? '💾 Atualizar' : '✅ Cadastrar'}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={handleCancelar}>
                                    ❌ Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* LISTA */}
            <div className="card">
                <div className="card-header">
                    <h5 className="mb-0">🏨 Lista de Hotéis Parceiros</h5>
                </div>
                <div className="card-body">
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary"></div>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-striped table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Nome</th>
                                        <th>CNPJ</th>
                                        <th>Local</th>
                                        <th>Telefone</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {hoteis.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted">
                                                Nenhum hotel parceiro cadastrado
                                            </td>
                                        </tr>
                                    ) : (
                                        hoteis.map((hotel) => (
                                            <tr key={hotel.id}>
                                                <td>{hotel.nome}</td>
                                                <td>{formatarCnpj(hotel.cnpj)}</td>
                                                <td>{hotel.local}</td>
                                                <td>{hotel.telefone || '-'}</td>
                                                <td className="text-center text-nowrap">
                                                    <button
                                                        onClick={() => handleEditar(hotel)}
                                                        className="btn btn-sm btn-warning me-2"
                                                    >
                                                        ✏️ Editar
                                                    </button>
                                                    <button
                                                        onClick={() => handleDeletar(hotel)}
                                                        className="btn btn-sm btn-danger"
                                                    >
                                                        🗑️ Excluir
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HoteisParceiros;